<template>
  <a-modal :visible="visible" title="User Guides" :footer="null" @cancel="closeModal">
    <div class="flex flex-column gap-3">
      <!-- <p class="flex justify-content-between">
        <b>App Sections Tour</b>
        <a-button icon="play-circle" @click="startLayoutTour"> Start </a-button>
      </p> -->

      <h4 class="m-0 text-center">Associate Pages</h4>
      <p class="flex justify-content-between">
        <b>Shifts</b>
        <a-button icon="play-circle" @click="startAssociateShiftsTour"> Start </a-button>
      </p>
      <p class="flex justify-content-between">
        <b>Profiles</b>
        <a-button icon="play-circle" @click="startAssociateProfilesTour"> Start </a-button>
      </p>
      <p class="flex justify-content-between">
        <b>Violations</b>
        <a-button icon="play-circle" @click="startAuthsTour"> Start </a-button>
      </p>

      <h4 class="m-0 text-center">Payments Pages</h4>
      <p class="flex justify-content-between">
        <b>Payments</b>
        <a-button icon="play-circle" @click="startPaymentsTour"> Start </a-button>
      </p>
    </div>
  </a-modal>
</template>

<script>
import { Button, Modal } from 'ant-design-vue'

export default {
  components: {
    'a-modal': Modal,
    'a-button': Button
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:visible', false)
    },

    startLayoutTour() {
      this.closeModal()

      this.$tours.layoutTour.start()
    },

    startAssociateShiftsTour() {
      this.closeModal()

      if (this.currentRoute === 'shifts') {
        this.$nextTick(() => {
          this.$tours.shiftsTour.start()
        })
      } else {
        this.$router
          .push('shifts')
          .then(() => {
            this.$nextTick(() => {
              this.$tours.shiftsTour.start()
            })
          })
          .catch(() => {})
      }
    },

    startAssociateProfilesTour() {
      this.closeModal()

      if (this.currentRoute === 'associate-profiles') {
        this.$nextTick(() => {
          this.$tours.profilesTour.start()
        })
      } else {
        this.$router
          .push('associate-profiles')
          .then(() => {
            this.$nextTick(() => {
              this.$tours.profilesTour.start()
            })
          })
          .catch(() => {})
      }
    },

    startPaymentsTour() {
      this.closeModal()

      if (this.currentRoute === 'payments-request') {
        this.$nextTick(() => {
          this.$tours.paymentsTour.start()
        })
      } else {
        this.$router
          .push('payments-request')
          .then(() => {
            this.$nextTick(() => {
              this.$tours.paymentsTour.start()
            })
          })
          .catch(() => {})
      }
    },

    startAuthsTour() {
      this.closeModal()

      if (this.currentRoute === 'project-shift-auths') {
        this.$nextTick(() => {
          this.$tours.authsTour.start()
        })
      } else {
        this.$router
          .push('project-shift-auths')
          .then(() => {
            this.$nextTick(() => {
              this.$tours.authsTour.start()
            })
          })
          .catch(() => {})
      }
    }
  }
}
</script>
